/** Typed postMessage protocol for BanyanPro ↔ TKM embed (Phase 4). */

export const TKM_MESSAGE_TYPES = {
  EMBED_READY: 'TKM_EMBED_READY',
  LAUNCH_SUCCESS: 'TKM_LAUNCH_SUCCESS',
  LAUNCH_ERROR: 'TKM_LAUNCH_ERROR',
  BANYANPRO_ASSERTION: 'BANYANPRO_ASSERTION',
} as const;

export type TkmEmbedReadyMessage = {
  type: typeof TKM_MESSAGE_TYPES.EMBED_READY;
};

export type TkmLaunchSuccessMessage = {
  type: typeof TKM_MESSAGE_TYPES.LAUNCH_SUCCESS;
  payload?: {
    /** Post-login path inside TKM (no tokens). */
    path?: string;
  };
};

export type TkmLaunchErrorMessage = {
  type: typeof TKM_MESSAGE_TYPES.LAUNCH_ERROR;
  payload: {
    code: string;
    message: string;
  };
};

export type BanyanproAssertionMessage = {
  type: typeof TKM_MESSAGE_TYPES.BANYANPRO_ASSERTION;
  payload: {
    assertion_jwt: string;
  };
};

export type TkmOutboundMessage = TkmEmbedReadyMessage | TkmLaunchSuccessMessage | TkmLaunchErrorMessage;

export type BanyanproInboundMessage = BanyanproAssertionMessage;

export function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}

export function parseBanyanproInboundMessage(data: unknown): BanyanproInboundMessage | null {
  if (!isRecord(data) || data.type !== TKM_MESSAGE_TYPES.BANYANPRO_ASSERTION) {
    return null;
  }
  const payload = data.payload;
  if (!isRecord(payload)) {
    return null;
  }
  const jwt = payload.assertion_jwt;
  if (typeof jwt !== 'string' || !jwt.trim()) {
    return null;
  }
  return {
    type: TKM_MESSAGE_TYPES.BANYANPRO_ASSERTION,
    payload: { assertion_jwt: jwt.trim() },
  };
}

export function createEmbedReadyMessage(): TkmEmbedReadyMessage {
  return { type: TKM_MESSAGE_TYPES.EMBED_READY };
}

export function createLaunchSuccessMessage(path?: string): TkmLaunchSuccessMessage {
  return {
    type: TKM_MESSAGE_TYPES.LAUNCH_SUCCESS,
    payload: path ? { path } : undefined,
  };
}

export function createLaunchErrorMessage(code: string, message: string): TkmLaunchErrorMessage {
  return {
    type: TKM_MESSAGE_TYPES.LAUNCH_ERROR,
    payload: { code, message },
  };
}
